import { useCallback } from 'react'
import { User } from 'schema'
import { notificationHandler } from 'hooks/notificationHandler'
import { dateFormatter } from '../../../../../../../../utils/dateFormatter'

export function useCreationNotification<
  T extends { createdDate: any; requestedBy: Pick<User, 'mail'> }
>() {
  const callback = useCallback(
    ({ createdDate, requestedBy: { mail } }: T, name: string) => {
      return notificationHandler({
        alternateType: 'success',
        title: `${name} successfully made at ${dateFormatter.shortDatetime(
          createdDate
        )}`,
        details: `An email will be sent to ${mail} with more details.`,
      })
    },
    []
  )

  return callback
}
